import * as React from "react";
import { ICard } from "./Card.types";

const Card = ({ headerIcon, title, description }: ICard) => {
  return (
    <div className="flex flex-col w-[298px] min-h-[300px] m-auto p-8 gap-y-4 rounded-[7px] bg-white shadow-lg">
      <span className="w-16 h-16 flex items-center">{headerIcon}</span>
      <p className="font-bold">{title}</p>
      <p>{description}</p>
    </div>
  );
};

export default Card;
